const doc = [({"ja":({"dining":"ダイニング", "bars":"バー", "activities":"アクティビティ", "entertainment":"エンターテインメント", "kidsAndTeens":"子ども向け", "spaAndFitness":"スパ＆フィットネス"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;